import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle, XCircle, CircleNotch } from "@phosphor-icons/react";
import { verifyEmailApi, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function VerifyEmailPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { user, refresh } = useAuth();
  const [state, setState] = useState("loading");
  const [error, setError] = useState("");
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    verifyEmailApi(params.get("token") || "")
      .then(() => { setState("ok"); refresh(); })
      .catch((e) => { setError(formatApiErrorDetail(e.response?.data?.detail)); setState("error"); });
  }, [params, refresh]);

  return (
    <div className="stp-bg flex min-h-screen items-center justify-center px-5">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="stp-card w-full max-w-md rounded-3xl p-10 text-center" data-testid="verify-email-page">
        {state === "loading" && <><CircleNotch size={48} className="mx-auto animate-spin text-brand" /><h1 className="mt-5 font-display text-3xl font-semibold text-ink">Verifying…</h1></>}
        {state === "ok" && <><CheckCircle size={60} weight="fill" className="mx-auto text-[#34C759]" /><h1 data-testid="verify-email-success" className="mt-5 font-display text-3xl font-semibold text-ink">Email verified</h1><p className="mt-2 text-mist">Thanks! Your account is all set.</p></>}
        {state === "error" && <><XCircle size={60} weight="fill" className="mx-auto text-[#D70015]" /><h1 className="mt-5 font-display text-3xl font-semibold text-ink">Link didn't work</h1><p data-testid="verify-email-error" className="mt-2 text-mist">{error}</p></>}
        {state !== "loading" && user !== null && (
          <button data-testid="verify-email-continue-button" onClick={() => navigate(user ? "/app" : "/login")} className="mt-8 h-12 w-full rounded-full bg-brand text-[15px] font-semibold text-white hover:bg-brand-hover">
            {user ? "Open workspace" : "Sign in"}
          </button>
        )}
      </motion.div>
    </div>
  );
}
